import { getComposeViewState } from 'owa-calendar-compose-store-manager';
import {
    enableOptionalAttendeesWell,
    enableFocusOptionalAttendeeWellOnMount,
} from 'owa-calendar-compose-form-actions';
import { mutator } from 'satcheljs';

export const showOptionalAttendeeWellMutator = mutator(
    enableOptionalAttendeesWell,
    actionMessage => {
        const composeViewState = getComposeViewState(actionMessage.formId);
        composeViewState.isOptionalAttendeeWellEnabled = true;
    }
);

export const focusOptionalAttendeeWellMutator = mutator(
    enableFocusOptionalAttendeeWellOnMount,
    actionMessage => {
        const composeViewState = getComposeViewState(actionMessage.formId);
        composeViewState.shouldFocusOptionalAttendeeWellOnMount = actionMessage.enableFocus;
    }
);
